import React, { useState } from 'react';
import {
    Loader,
} from './index.js';
import { RowCopia } from '../RowCopia.js';

import { usePatrocinado } from '../../hooks/usePatrocinado.js';
import { Spinner } from '@material-tailwind/react';
import Main from '../../../../componentes/Main.js';
import { PanelDatosGenerales } from '../modulos/componentes/PanelDatosGenerales';

export const TR_PatrocinadoNew = ({ id, cabecera, setData, usuario, snackbar, puedeEditarse, cambiarStatus,finalizar }) => {

    const {
        error, loading, loading2, procesando, datosDelTramite, status_actual_tramite,
        acta_regional, setActa_regional, fechaAR, handleChangeFechaAR, setActa_cdn, fechaACDN,
        handleChangeFechaACDN, inicioActualizacionTramite, actualizarTramite, touched, refrescar,
        acta_cdn, refrescando, traerUrl, accederEntrevista, IniciarCerrarEntrevista,
        analitico, handleChangeAnaliticoCheck, nuevoAnalitico, setNuevoAnalitico,
        cambiarAnalitico, setCambiarAnalitico, nuevoExtra1, setNuevoExtra1,
        cambiarExtra1, setCambiarExtra1, linkEntrevista, copiarLink
    } = usePatrocinado(cabecera, id, setData, usuario, snackbar);

    const [activeTab, setActiveTab] = useState('informacion_general');

    if (error) return <div className="p-4 bg-red-50 text-red-700 rounded-lg"><p>{JSON.stringify(error)}</p></div>;
    
    if (loading || loading2 || procesando) {
        return (
            <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)] gap-3'>
                    <Spinner className="h-12 w-12 text-blue-500" />
                    <span className="font-semibold text-gray-600 text-sm">Cargando...</span>
                </div>
            </Main>
        );
    }
    
    if (!datosDelTramite) return <div className="p-8 text-center"><Spinner className="h-12 w-12 mx-auto text-blue-500" /><p className="text-gray-500 mt-2">Cargando solicitud...</p></div>;

    return (
        <div id="solicitud-proceso" className="w-full mx-auto space-y-4 antialiased text-gray-800">
            <Loader open={refrescando} />
            <div className="flex flex-col col-span-1 lg:col-span-7 bg-gray-50 border border-gray-200 rounded-md p-2  shadow-sm overflow-y-auto max-h-[500px]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left items-start antialiased">
                    
                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                valor: `${datosDelTramite.nombre} ${datosDelTramite.apellido}`,
                                descripcion: 'Nombre completo'
                            },
                            {
                                valor: datosDelTramite.email,
                                descripcion: 'E-mail'
                            }
                        ]}
                    />

                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                valor: datosDelTramite.activo ? 'Activo' : 'Desactivado',
                                descripcion: 'Link de continuación del trámite:'
                            },                                                         
                            {
                                descripcion: 'Link de continuación del trámite:',
                                valor: (
                                    <div className="space-y-3">
                                        <RowCopia titulo="Puede copiar el link para reenviarlo al ministro" link={`https://ministros.uad.digital/externos/temporal/${datosDelTramite._id}`} versionPlana={true} />
                                    </div>
                                )
                            },
                        ]}
                    />                    
                </div>

            </div>
        </div>
    );
};
